<div class="contract-details-form-container" [formGroup]="contractForm" fxLayout="column" fxLayoutGap="15px">
  <div class="status-info">
    <app-dict
      [label]="'Status'" [dictType]="'contract_status'"
      formControlName="status"
      [control]="statusControl"
      [required]="true"
      [multiple]="false"
      appearance="fill"
      [color]="true"
    ></app-dict>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <ng-container ><button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button></ng-container>
<!--    <ng-container *ngIf="contractForm.get('partner').value && contractType?.key === CONTRACT_TYPE_SELF_BILLING && !getListOfVatButton"><button (click)="getListOfVat()"  mat-stroked-button color="primary" matTooltip="Wykaz Podatnikow Vat" class="active"><mat-icon>send</mat-icon><span> Pobierz dane z rejestru podatników VAT</span></button></ng-container>-->

    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" *ngIf="contractObject">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-dict *ngIf="contractObject.ofwca"
                          [label]="'Rodzaj umowy'" [dictType]="'contract_type'"
                          [control]="typeControl"
                          [required]="true"
                          [multiple]="false"
                          [onlyKeys]="OFWCA_TYPES"
                          (selectedDict)="contractTypeChanged($event)"
                ></app-dict>

                <app-dict *ngIf="contractObject.partner.nip"
                          [label]="'Rodzaj umowy'" [dictType]="'contract_type'"
                          [control]="typeControl"
                          [required]="true"
                          [multiple]="false"
                          [onlyKeys]="PARTNER_TYPES"
                          [skipKeys]="[CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE, CONTRACT_TYPE_LEAD_ONLY_HEALTH]"
                          (selectedDict)="contractTypeChanged($event)"
                ></app-dict>

                <app-dict *ngIf="!contractObject.partner.nip"
                          [label]="'Rodzaj umowy'" [dictType]="'contract_type'"
                          [control]="typeControl"
                          [required]="true"
                          [multiple]="false"
                          [onlyKeys]="PARTNER_TYPES"
                          (selectedDict)="contractTypeChanged($event)"
                ></app-dict>
              </div>

              <div fxFlex="50">
                <app-datepicker
                  label="Data zawarcia"
                  placeholder="2000-01-01"
                  [required]="true"
                  [control]="concludeDateControl"
                ></app-datepicker>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-dict
                  [label]="'Firma'" [dictType]="'company'"
                  [control]="companyControl"
                  [required]="true"
                  [multiple]="false"
                ></app-dict>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Numer</mat-label>
                  <input [required]="true" matInput placeholder="Numer" formControlName="number">
                  <mat-error *ngIf="contractForm.get('number').hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="contractForm.get('number').hasError('backendError')">
                    {{contractForm.get('number').getError('backendError')}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-datepicker
                  label="Aktywna od"
                  placeholder="2000-01-01"
                  [required]="false"
                  [control]="activeFromControl"
                ></app-datepicker>
              </div>

              <div fxFlex="50">
                <app-datepicker
                  label="Data zakończenia"
                  placeholder="2000-01-01"
                  [required]="requiredActiveTo"
                  [control]="activeToControl"
                ></app-datepicker>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-dict
                  [label]="'Czas trwania'" [dictType]="'contract_period'"
                  [control]="periodControl"
                  [required]="true"
                  [multiple]="false"
                ></app-dict>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="terminationStatus">

              <div fxFlex="50">
                <app-dict
                  [label]="'Sposób rozwiązania'" [dictType]="'termination_type'"
                  [control]="terminationTypeControl"
                  [required]="true"
                  [multiple]="false"
                  (selectedDict)="onTerminationTypeChange($event)"
                ></app-dict>
              </div>

              <div fxFlex="50">
                <app-dict
                  [label]="'Okres wypowiedzenia'" [dictType]="'termination_time'"
                  [control]="terminationTimeControl"
                  [required]="true"
                  [multiple]="false"
                  (selectedDict)="onTerminationTimeChange($event)"
                ></app-dict>
              </div>

            </div>

            <ng-container *ngIf="requireCancellationFields">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <app-dict
                    [label]="'Powód anulowania'" [dictType]="'contract_cancellation_reason'"
                    [control]="cancellationReasonControl"
                    [required]="true"
                    [multiple]="false"
                  ></app-dict>
                </div>
              </div>

              <div fxLayout="row">
                <mat-form-field fxFlex="100">
                  <mat-label>Wyjaśnienie anulowania</mat-label>
                  <textarea formControlName="cancellationExplanation" matInput placeholder="Wyjaśnienie anulowania"></textarea>
                </mat-form-field>
              </div>
            </ng-container>

            <div fxLayout="row" *ngIf="[
              CONTRACT_STATUS_DURING_TERMINATION,
              CONTRACT_STATUS_TERMINATED,
              CONTRACT_STATUS_TO_TERMINATE,
              CONTRACT_STATUS_CLOSED,
            ].includes(contractObject?.status?.key)">
              <mat-form-field fxFlex="100">
                <mat-label>Powód rozwiązania</mat-label>
                <textarea formControlName="terminationReason" matInput placeholder="Powód rozwiązania"></textarea>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="verified">Rekord zweryfikowany</mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" contractObject.type.key === CONTRACT_TYPE_PARTNERSHIP">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="customRates">Stawki niestandardowe</mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" contractObject.type.key === CONTRACT_TYPE_PARTNERSHIP">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" [formControl]="assignedContractControl">Umowa przepisywana </mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="assignedContractControl.value">
              <div fxFlex="100">
                <app-dict-partners
                  fxFlex="100" label="Partner, z którego przepisujemy umowę"
                  [control]="assignedPartnerControl" [required]="true"
                ></app-dict-partners>
              </div>
            </div>

            <ng-container *ngIf="(userPermissions | async).contract.admin_root && (contractObject.type.key === CONTRACT_TYPE_SELF_BILLING || contractObject.type.key === CONTRACT_TYPE_PARTNERSHIP || contractObject.type.key === CONTRACT_TYPE_PROFIT)">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="invoiceServiceDate">Miesiąc sprzedaży aktualny</mat-slide-toggle>
              </div>
            </div>
              <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" [formControl]="selfBillingExpectsControl">Oczekuje</mat-slide-toggle>
                <ng-container *ngIf="selfBillingExpectsDateControl.value"> ({{selfBillingExpectsDateControl.value | date:'y-MM-dd' }})</ng-container>
              </div>
            </div>
            </ng-container>
            <ng-container *ngIf="[
              CONTRACT_TYPE_PARTNERSHIP , CONTRACT_TYPE_PROFIT
            ].includes(contractObject?.type?.key) && isCustomCommission">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <mat-slide-toggle color="accent" [formControl]="automaticBillingControl">Automatyczne rozliczanie</mat-slide-toggle>
                </div>
              </div>
            </ng-container>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="CUSTOM_TERMS_CONTRACT_TYPES.includes(contractObject?.type?.key)">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="customTerms">Niestandardowe zapisy w umowie</mat-slide-toggle>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="contractType?.key === CONTRACT_TYPE_SELF_BILLING || contractType?.key === CONTRACT_TYPE_PARTNERSHIP  || contractType?.key === CONTRACT_TYPE_PROFIT">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">

              <ng-container *ngIf="contractType?.key === CONTRACT_TYPE_SELF_BILLING">
                <h3 >Dane umowy na samofakturowanie</h3>
              </ng-container>
              <ng-container *ngIf="contractType?.key === CONTRACT_TYPE_PARTNERSHIP || contractType?.key === CONTRACT_TYPE_PROFIT">
                <h3 >Dane do zestawienia prowizyjnego</h3>
              </ng-container>

            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Email</mat-label>
                <input matInput placeholder="adres@asf.com.pl" [formControl]="selfBillingEmailControl" [required]="true">
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Numer telefonu</mat-label>
                <input matInput placeholder="+48 500 200 300" [formControl]="selfBillingPhoneControl" [required]="true" prefix="+48" mask=" 000 000 000">
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Numer rachunku bankowego</mat-label>
                <input
                  prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                  matInput placeholder="PL27 1140 2004 0000 3002 0135 5387" [formControl]="selfBillingAccountNumberControl"
                >
                <mat-error *ngIf="selfBillingAccountNumberControl.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="vatTaxpayersAccountNumber.length > 0">
              <div fxFlex="100">
                <app-detail header="numer rachunku bankowego zgłoszony do rejestru płatników VAT">
                  <mat-chip-list>
                    <ng-container *ngFor="let tag of vatTaxpayersAccountNumber; let last = last">
                      <mat-chip   color="accent" (click)="copyMessage(tag)">
                        <span>{{tag | mask: '00 0000 0000 0000 0000 0000 0000'}}</span>

                      </mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>

            <div fxLayout="row"  *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING">
              <mat-slide-toggle [formControl]="selfBillingVatPayerControl" color="accent">Zarejestrowany jako płatnik VAT</mat-slide-toggle>
            </div>

            <div fxLayout="row"  *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING">
              <mat-slide-toggle [formControl]="selfBillingActiveVatPayerControl" color="accent">Płatnik VAT czynny</mat-slide-toggle>
            </div>

            <div fxLayout="row"  *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING">
              <mat-slide-toggle [formControl]="selfBillingCheckoutMethodControl" color="accent">Metoda kasowa</mat-slide-toggle>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Strona umowy" [value]="contractObject.owner?.name"></app-detail>
            </div>

            <ng-container *ngIf="contractObject.partner">
              <div fxLayout="row">
                <app-detail fxFlex="100" header="Partner" [value]="contractObject.partner?.shortName" [link]="['/partnerzy/szczegoly', contractObject.partner?.uuid]"></app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Tagi partnera">
                  <ng-container *ngFor="let tag of contractObject.partner.tags; let last = last">
                    {{tag.name}}<ng-container *ngIf="!last">,</ng-container>
                  </ng-container>
                </app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Regionalny (majątek)"
                            [value]="contractObject.partner.assetsRegional ? contractObject.partner.assetsRegional?.fullName : 'Brak'"></app-detail>
              </div>
            </ng-container>

            <ng-container *ngIf="contractObject.ofwca">
              <div fxLayout="row">
                <app-detail fxFlex="100" header="OFWCA" [value]="contractObject.ofwca?.fullName"
                            [link]="['/ofwca/szczegoly', contractObject.ofwca?.uuid]"></app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Regionalny (majątek)"
                            [value]="contractObject.ofwca.assetsRegional ? contractObject.ofwca.assetsRegional?.fullName : 'Brak'"></app-detail>
              </div>

            </ng-container>

            <div fxLayout="row">
              <div fxFlex="100" class="parent-contract-control" *ngIf="showPartnershipContractSelect">
                <app-dict-contracts
                  fxFlex="100" label="Umowa Współpracy"
                  [control]="parentContractControl" [required]="false"
                  [contracts]="contracts"
                  [excludeId]="contractObject.uuid"
                ></app-dict-contracts>
              </div>
            </div>

            <div fxLayout="row"     class="parent-contract-control" >
              <div fxFlex="100" >
                <app-partner-facility-select
                  label="Placówka" fxFlex="100"
                  [required]="false"
                  [control]="facilityControl"
                  [partnerId]="partnerControl.valueChanges"
                ></app-partner-facility-select>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"   *ngIf="commissionTableRequired">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Tabela prowizyjna</h3>
            </div>

            <div fxLayout="row" >
              <div fxFlex="100" >
              <app-dict-commission-tables
                label="Tabela prowizyjna"
                [control]="commissionTableControl"
                [commissionTables]="commissionTables"
                [companyId]="companyControl.value"
                [contractTypeId]="typeControl.value"
                [required]="commissionTableRequired"
              ></app-dict-commission-tables>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <textarea formControlName="note" matInput placeholder="Uwagi"></textarea>
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <ng-container ><button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button></ng-container>
<!--    <ng-container *ngIf="contractForm.get('partner').value && contractType?.key === CONTRACT_TYPE_SELF_BILLING && !getListOfVatButton"><button (click)="getListOfVat()"  mat-stroked-button color="primary" matTooltip="Wykaz Podatnikow Vat" class="active"><mat-icon>send</mat-icon><span> Pobierz dane z rejestru podatników VAT</span></button></ng-container>-->

    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
